import React from "react";
import PropTypes from "prop-types";
import SwiperCore, { A11y, Keyboard, Lazy, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { applyTransformations } from "../../utils";

import ComponentBroker from "../brokers/component-broker";

import * as styles from "swiper/swiper.scss";
import * as stylesA11y from "swiper/components/a11y/a11y.scss";
import * as stylesLazy from "swiper/components/lazy/lazy.scss";
import * as stylesNavigation from "swiper/components/navigation/navigation.scss";
import * as stylesPagination from "swiper/components/pagination/pagination.scss";

// install Swiper Modules
SwiperCore.use([A11y, Keyboard, Lazy, Navigation, Pagination]);

const Slideshow = ({ slides, ...props }) => {
  return (
    <Swiper
      style={{
        ...styles,
        ...stylesA11y,
        ...stylesLazy,
        ...stylesNavigation,
        ...stylesPagination
      }}
      {...props}
    >
      {slides &&
        slides.map((image) => {
          if (image.media) {
            image.media.url = applyTransformations(image.media?.data?.attributes?.url, { w: 950 });
            image.media.className = "swiper-lazy";
            image.media.dataSrc = true;
          }
          return (
            <SwiperSlide key={`${image.__typename}-${image.id}`}>
              <ComponentBroker component={image} />
              <div className="swiper-lazy-preloader"></div>
            </SwiperSlide>
          );
        })}
      <span slot="container-end">
        <div className="swiper-pagination"></div>
      </span>
    </Swiper>
  );
};

Slideshow.propTypes = {
  slides: PropTypes.array
};

Slideshow.defaultProps = {
  a11y: true,
  autoHeight: true,
  centeredSlides: true,
  grabCursor: true,
  keyboard: true,
  lazy: {
    loadOnTransitionStart: true,
    loadPrevNext: true,
    loadPrevNextAmount: 2
  },
  loop: true,
  navigation: true,
  pagination: { clickable: true, el: ".swiper-pagination" },
  slidesPerView: 1,
  spaceBetween: 0,
  threshold: 30,
  uniqueNavElements: true
};

export { SwiperSlide };
export default Slideshow;
